import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@bowling-eisleben.de");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Anmeldung fehlgeschlagen");
      toast.error("Anmeldung fehlgeschlagen");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 p-4 relative overflow-hidden">
      <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full bg-teal-200/40 blur-3xl" />
      <div className="absolute -bottom-24 -left-24 h-96 w-96 rounded-full bg-emerald-200/40 blur-3xl" />

      <div className="relative w-full max-w-md">
        <div className="flex flex-col items-center mb-6">
          <img src="/haccp-logo.png" alt="HACCP" className="h-20 w-20 object-contain drop-shadow-sm" />
          <h1 className="font-heading text-2xl font-bold text-slate-900 mt-3">HACCP-Dokumentation</h1>
          <p className="text-sm text-slate-500">Bowlingcenter Eisleben</p>
        </div>

        <form
          onSubmit={submit}
          data-testid="login-form"
          className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6 sm:p-8 space-y-4"
        >
          <div className="space-y-1.5">
            <Label htmlFor="email">E-Mail</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              required
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password">Passwort</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              required
            />
          </div>
          {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
          <Button type="submit" disabled={busy} data-testid="login-submit" className="w-full">
            {busy && <Loader2 className="h-4 w-4 animate-spin mr-2" />}
            Anmelden
          </Button>
          <p className="text-center text-xs text-slate-400">
            Sichere Dokumentation nach EU-VO 852/2004 / LMHV
          </p>
        </form>
      </div>
    </div>
  );
}
